(function(){
  document.addEventListener('DOMContentLoaded', function() {
    let addToBtn = document.querySelector('.add_bundle');
    addToBtn.addEventListener('click', function(e) {
      
      e.preventDefault();
      let formData = {'items': []};
      
      document.querySelectorAll('.needed_items .neede_item').forEach(elem => {
        let id = elem.getAttribute('data-add-id');
        
        formData.items.push({'id': id,'quantity': 1});
      });
      addToCart(formData);
    });
    
    function addToCart(formData) {
       fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        console.log(response);
          if ( response.status == 200 ) {
            alert('Success!');
            document.location.href = window.Shopify.routes.root + 'cart/'
            return response.json();
          } else {
            alert('Something goes wrong, write to support.');
          }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
 }, false);
})();